const appConfigUAT = [
  {
    id: 1,
    capability_name: "Spend Analytics",
    capability_desc: "Unlocking Value Through Data: Transforming spend insights into strategic action.",
    apps: [
      {
        app: "Spend HQ",
        id: 1,
        url: "https://secure2-auth.spendhq.com/authorize?client_id=vsiASniJaZjBAtJm40J0X5pcF4TyIxO7&connection=Pepsico&response_type=token&redirect_uri=https://secure2.spendhq.com/idpcallback",
        tooltipText: 'Analyze. Visualize. Optimize your spend with near real-time insights.',
        display: true
      },
      {
        app: "AMESA PBI",
        id: 2,
        url: "https://app.powerbi.com/groups/42819fb6-cb60-4fa2-95af-d622fc27ad22/reports/b7409d77-4128-4e2d-a042-c79a65893139/ReportSectionbde8ef93711b554ec5fa?experience=power-bi",
        tooltipText: 'Amesa',
        display: true
      },
      {
        app: "Spendwise",
        id: 3,
        url: "https://spendwise.mypepsico.com",
        tooltipText: 'Stay compliant and spend smart — every purchase within policy.',
        display: true
      }
    ],
  },
  {
    id: 2,
    capability_name: "Commodity Buy Plan",
    capability_desc: "Precision Planning for Smarter Commodity Buying: Aligning needs, markets, and strategy.",
    apps: [
      {
        app: "Compass",
        id: 1,
        tooltipText: 'Central hub for committing your buy plans and covered plan',
        url: "https://mycompass.mypepsico.com/home",
        display: true
      },
    ],
  },
  {
        id: 3,
        capability_name: "Market Intelligence",
        capability_desc: "Stay Ahead of the Curve: Actionable market insights for smarter procurement decisions.",
        info: "Note: FastMarkets (RISI), CMA, Woodmac and S&P Global are not SSO enabled.",
        apps: [
            {
                app: "SmartCube",
                id: 1,
                tooltipText: 'Get instant market intelligence with ready-to-use category reports.',
                url: "https://amplifipro.thesmartcube.com/pepsico/login",
                display: true
            },
            {
                app: "In-house MI Team",
                id: 1,
                tooltipText: 'Request and explore tailored market insights crafted by our in-house MI experts.',
                url: "https://pepsico.sharepoint.com/sites/MarketIntelligence-ProjectRepository/Shared%20Documents/Forms/AllItems.aspx",
                display: true
            },
            {
              app: "Seed Allocator",
              id: 1,
              tooltipText: 'Smart, data-driven supplier allocation',
              url: "https://app.powerbi.com/groups/me/reports/f4d116c1-0e12-45a1-8592-e022ce0396f3/baf2385e309092aace8d?experience=power-bi",
              display: true
            },
            {
              app: "FastMarkets (RISI)",
              id: 1,
              tooltipText: 'Live commodity prices and forecasts.',
              // url: "https://www.risiinfo.com/sso/",
              url: "https://dashboard.fastmarkets.com/",
              display: true
            },
            {
              app: "CMA",
              id: 1,
              tooltipText: 'Live Resin Prices and Forecasts',
              url: "https://cma.opisnet.com",
              display: true
            },
            {
              app: "Woodmac",
              id: 1,
              tooltipText: 'Live Resin Prices and Forecasts.',
              // url: "https://www.risiinfo.com/sso/",
              url: "https://my.woodmac.com",
              display: true
            },
            // {
            //   app: "SBAcci",
            //   id: 1,
            //   // tooltipText: 'Live commodity prices and forecasts.',
            //   // url: "https://www.risiinfo.com/sso/",
            //   // url: "https://dashboard.fastmarkets.com/",
            //   display: true
            // },
            {
              app: "S&P Global",
              id: 1,
              tooltipText: 'Historical and Forecast prices for Food and Agriculture commodities from S&P Global.',
              // url: "https://www.risiinfo.com/sso/",
              url: "https://connect.spglobal.com",
              display: true
            },
            // {
            //   app: "Chemical Market Analysis",
            //   id: 1,
            // tooltipText: 'Spend',
            //   url: "https://cma.opisnet.com/dashboard",
            //   display: true
            // },
        ],
    },
  {
    id: 4,
    capability_name: "Should Cost Modelling",
    capability_desc: "Unveiling True Costs: Driving value with data-driven cost transparency.",
    apps: [
      {
        app: "SCM Platform",
        id: 1,
        tooltipText: 'Estimate true product costs and uncover saving levers with data-driven cost models.',
        url: "https://scm.mypepsico.com/",
        display: true
      },
    ],
  },
  {
    id: 12,
    capability_name: "Sustainability Score",
    capability_desc: "Driving responsible procurement for a greener, more sustainable future.",
    apps: [
      {
        app: "Sustainability Action Center",
        id: 1,
        tooltipText: 'Track, measure, and accelerate progress on sustainability and supplier ESG goals.',
        url: "https://www.sustainabilityaction.pepsico.com/user/prelogin?oktaloginsso=X2hgKBmDOC5Y68FhwOIhEzSCqyKUTVb1",
        display: true
      },
    ],
  },
  {
    id: 5,
    capability_name: "Category Management",
    capability_desc: "Strategize smarter with 360° category insights and collaborative tools.",
    info: "Applicable for AMESA & PGCS",
    apps: [
      {
        app: "Cirtuo",
        id: 1,
        tooltipText: 'AI-guided category strategy creation.',
        url: "http://pepsico.cirtuo.com/login.php?sso",
        display: true
      }
    ],
  },
  {
    id: 6,
    capability_name: "CoMan Automation",
    capability_desc: "Track, measure, and elevate supplier excellence for better outcomes.",
    apps: [
      // {
      //   app: "Global SPM",
      //   id: 1,
      // tooltipText: 'Drive supplier performance and collaboration.',
      //   url: "https://app.powerbi.com/groups/e6b93592-7061-4020-a489-e25996c6154b/reports/88da15f9-439c-4f66-824e-2cc8be2076d4/8233098d914c011cc802?experience=power-bi&clientSideAuth=0",
      //   display: true
      // },
      {
        app: "CoMan Automation",
        id: 1,
        tooltipText: 'CoMan Automation',
        url: "https://app.powerbi.com/groups/me/reports/e9cea7d8-7ae2-436c-9936-85f9e24d9ab2/f962eedba913ba1bab9f?ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&openReportSource=ReportInvitation&experience=power-bi",
        display: true
      },
    ],
  },
  {
    id: 7,
    capability_name: "Supplier Risk",
    capability_desc: "Mitigate risks proactively with real-time supplier risk monitoring.",
    apps: [
      {
        app: "Resilinc",
        id: 1,
        tooltipText: 'Real-time supplier risk monitoring.',
        url: "https://authen.resilinc.com/saml/login?disco=true&idp=http://www.okta.com/exk1v4t74rzpW9QSd0h8",
        display: true
      },
    ],
  },
  {
    id: 8,
    capability_name: "Supplier Discovery",
    capability_desc: "Harness AI to uncover and connect with the best-fit suppliers globally.",
    // info: "SSO is WIP as this is under pilot",
    apps: [
      // {
      //   app: "Veridion",
      //   id: 1,
      //   tooltipText: 'Accelerate supplier discovery with real-time, AI-powered global supplier intelligence.',
      //   url: "https://platform.veridion.com/",
      //   display: true
      // },
      {
        app: "Forestreet",
        id: 1,
        tooltipText: 'Discover innovative suppliers with AI-driven market and capability insights.',
        url: "https://ailsa.forestreet.com/sign-in-sso",
        display: true
      },
    ],
  },
  {
    id: 9,
    capability_name: "Sourcing (Launch RFx, Negotiation)",
    capability_desc: "Streamline sourcing with seamless RFx launches and smart negotiations.",
    apps: [
      // {
      //   app: "SAP Ariba",
      //   id: 1,
      // tooltipText: 'SAP Ariba',
      //   url: "https://s1.ariba.com/Sourcing/Main/aw?awh=r&awssk=XF0dhMWNl6y5gQBF&realm=PepsiCoreporting&dard=1",
      //   display: true
      // },   
      {
        app: "Archlet",
        id: 1,
        tooltipText: 'Run smart, AI-powered sourcing events and optimize supplier choices.',
        url: "https://login.archlet.io/authorize?client_id=dYKXdHx8z5IViB1nrgr94DqH5P8N6cAg&response_type=code&scope=openid+profile+email&redirect_uri=https%3A%2F%2Fapp.archlet.io&connection=pepsico-saml-prod",
        display: true
      },
      {
        app: "SAP Ariba (SSS)",
        id: 1,
        tooltipText: 'Manage sourcing events, compare bids, and select the best suppliers — all in one place.',
        url: "https://s1.ariba.com/Sourcing/Main/aw?awh=r&awssk=XF0dhMWNl6y5gQBF&realm=PepsiCoreporting&dard=1",
        display: true
      },
      {
        app: "SAP Ariba (Standalone)",
        id: 1,
        tooltipText: 'Manage sourcing events, compare bids, and select the best suppliers — all in one place',
        url: "https://s1-2.ariba.com/Sourcing/Main/aw?awh=r&awssk=zcaB4a3WNDTU9rRQ&realm=PepsiCo&dard=1",
        display: true
      },
      {
              app: "Ariba Test",
              id: 1,
              tooltipText: 'Access Ariba Test [PGCS]',
              url: "https://s1.ariba.com/Buyer/Main/ad/loginPage/SSOActions?awsso_cc=cmVhbG06Y0dWd2MybGpiM0psY0c5eWRHbHVaeTEwO3Bhc3N3b3JkYWRhcHRlcjpWR2hwY21SUVlYSjBlVlZ6WlhJPTthd3Nzb19ydTphSFIwY0hNNkx5OXpNUzVoY21saVlTNWpiMjB2VTI5MWNtTnBibWN2VFdGcGJpOWhaQzlrWldaaGRXeDBMMFJwY21WamRFRmpkR2x2Ymo5d1lYTnpkMjl5WkdGa1lYQjBaWEk5VkdocGNtUlFZWEowZVZWelpYSW1jbVZoYkcwOWNHVndjMmxqYjNKbGNHOXlkR2x1WnkxMDthd3Nzb19sdTphSFIwY0hNNkx5OXpNUzVoY21saVlTNWpiMjB2VTI5MWNtTnBibWN2VFdGcGJpOWhaQzlqYkdsbGJuUk1iMmR2ZFhRdlUxTlBRV04wYVc5dWN3PT07YXdzc29fYXA6UVVOTjthd3Nzb19hcmlkOk1UYzFPRFl4TlRNNU5qRTNOZz09O2F3c3NvX2t1OmFIUjBjSE02THk5ek1TNWhjbWxpWVM1amIyMHZVMjkxY21OcGJtY3ZUV0ZwYmk5aFpDOWpiR2xsYm5STFpXVndRV3hwZG1VdlUxTlBRV04wYVc5dWN3PT07YXdzc29fZmw6TVE9PQ%3D%3D%3AucRY3Rmu%2BWQclqZhwPR7HGSUlFI%3D&awsso_ap=ACM&passwordadapter=ThirdPartyUser&realm=PepsiCo-T&awsr=true",
              display: true
          },
          {
              app: "Ariba Prod",
              id: 1,
              tooltipText: 'Access Ariba Prod [PGCS]',
              url: "https://secure.pepsico.com/app/mypepsico_aribarowparent_1/exk1o1dwrglNBfmnb0h8/sso/saml?externalSite=true",
              display: true
          },
          {
              app: "Ariba Training",
              id: 1,
              tooltipText: 'Access Ariba Training [PGCS]',
              url: "https://pepsico.sharepoint.com/teams/ProcurementPMO-Digitalization/Shared Documents/Digitalization/Procurement Hub/../../../../../sites/PGCSSAPAribaandmyBuy?e=1%3a9987599a37804ce6b48ce4a5bdbe4152&SafelinksUrl=https%3a%2f%2fpepsico.sharepoint.com%2fsites%2fPGCSSAPAribaandmyBuy&xsdata=MDV8MDJ8Q2hyaXN0aW5hLlNoZWFoYW5AcGVwc2ljby5jb218YWVjMjFhMjIxOTdhNGFjYTBkZjIwOGRlYTQ3MzdmMDF8NDJjYzMyOTVjZDBlNDQ5Y2I5OGU1Y2U1YjU2MGMxZDN8MHwwfDYzOTEyOTAxMzE1MTc5NzMwNXxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=MTArM2U4Y25MYWlmT3dKa2NmNnpFcG9lSXFHYjE4aFNZdExlcmY2dGN6Yz0%3d",
              display: true
          },
          {
              app: "Keelvar",
              id: 1,
              tooltipText: 'Automate sourcing events, optimize bids, and identify the best supplier awards with AI-powered sourcing.',
              url: "https://my.keelvar.app/api/v2/auth/sso_saml_request?provider=pepsico",
              display: true
          },
      // {
      //   app: "myBUY",
      //   id: 1,
      // tooltipText: 'myBUY',
      //   url: "https://s1.ariba.com/Buyer/Main/aw?awh=r&awssk=AkDf.YgRZAGtiA9I&realm=PepsiCo&dard=1",
      //   display: true
      // },
      // {
      //   app: "myRIS",
      //   id: 1,
      // tooltipText: 'myRIS',
      //   url: "https://app.powerbi.com/groups/me/reports/f12fad8f-5fff-4ab5-93eb-efe20cd6dcb1/1f88c127aca44206949a?ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&experience=power-bi",
      //   display: true
      // },
      // {
      //   app: "PSD Lite",
      //   id: 1,
      // tooltipText: 'PSD Lite',
      //   url: "https://app.powerbi.com/groups/me/reports/9cbfad86-10e8-4228-8b32-daa71c09e4ff/557e6b485ce5005ec13b?ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&experience=power-bi",
      //   display: true
      // }
    ],
  },
  {
    id: 10,
    capability_name: "Contracting",
    capability_desc: "Simplifying contract creation, management, and compliance with ease.",
    info: "Note: Terzo is not SSO enabled",
    apps: [
            {
                app: "Selectica",
                id: 1,
                tooltipText: 'Access & manage contracts from our legacy contract system.',
                url: "https://secure.pepsico.com/home/mypepsico_selectica_1/0oa1mys2crgihUNYw0h8/aln1mys7y6g4OGltn0h8",
                display: true
            },
            {
                app: "AMESA Contract Analytics",
                id: 1,
                tooltipText: 'AMESA Contract Analytics',
                url: "https://app.powerbi.com/groups/6b5771f2-bd7f-47fa-946c-572a2a984fb6/reports/85c7df45-04e9-4f70-a816-a5d6c80aaea5/ReportSectione0fc4b1867bbdaa9b5a4?ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&experience=power-bi",
                display: true
            },
            // {
            //   app: "SAP Ariba CLM",
            //   id: 1,
            //   tooltipText: 'Create, negotiate, and manage contracts digitally -ensuring compliance and visibility (applicable only for LATAM & Some parts of East Europe)',
            //   url: "https://s1.ariba.com/Sourcing/Main/ad/samlAuth/SSOActions?realm=pepsico",
            //   display: true
            // },
            {
                app: "Ariba CLM (LATAM & Europe)",
                id: 1,
                tooltipText: 'Create, negotiate, and manage contracts digitally -ensuring compliance and visibility (applicable only for LATAM & Some parts of East Europe)',
                url: "https://s1.ariba.com/Sourcing/Main/aw?awh=r&awssk=jnRi77YcMUIKgvt9&realm=PepsiCo&dard=1",
                display: true
            },
            {
                app: "Ariba CLM (NA)",
                id: 1,
                tooltipText: 'Create, negotiate, and manage contracts digitally -ensuring compliance and visibility (applicable only for LATAM & Some parts of East Europe)',
                url: "https://s1.ariba.com/Sourcing/Main/aw?awh=r&awssk=WL6rYYzOGZSkDX6L&realm=PepsiCoreporting&dard=1",
                display: true
            },
            {
              app: "T-Contract",
              id: 1,
              tooltipText: 'Digitize and track contracts end-to-end.',
              url: "https://pepsico.quickbase.com/nav/app/bm6dtckc8/action/appoverview?from=myqb",
              display: true
            },
            {
              app: "Fieldglass",
              id: 1,
              tooltipText: 'Source, manage, and track external workforce and service providers with ease.',
              url: "https://secure.pepsico.com/home/mypepsico_sapfieldglass_1/0oa1mj23hirf2tabu0h8/aln1mj2ga90O13LLv0h8",
              display: true
            },
        {
              app: "Ariba Test",
              id: 1,
              tooltipText: 'Access Ariba Test [PGCS]',
              url: "https://s1.ariba.com/Buyer/Main/ad/loginPage/SSOActions?awsso_cc=cmVhbG06Y0dWd2MybGpiM0psY0c5eWRHbHVaeTEwO3Bhc3N3b3JkYWRhcHRlcjpWR2hwY21SUVlYSjBlVlZ6WlhJPTthd3Nzb19ydTphSFIwY0hNNkx5OXpNUzVoY21saVlTNWpiMjB2VTI5MWNtTnBibWN2VFdGcGJpOWhaQzlrWldaaGRXeDBMMFJwY21WamRFRmpkR2x2Ymo5d1lYTnpkMjl5WkdGa1lYQjBaWEk5VkdocGNtUlFZWEowZVZWelpYSW1jbVZoYkcwOWNHVndjMmxqYjNKbGNHOXlkR2x1WnkxMDthd3Nzb19sdTphSFIwY0hNNkx5OXpNUzVoY21saVlTNWpiMjB2VTI5MWNtTnBibWN2VFdGcGJpOWhaQzlqYkdsbGJuUk1iMmR2ZFhRdlUxTlBRV04wYVc5dWN3PT07YXdzc29fYXA6UVVOTjthd3Nzb19hcmlkOk1UYzFPRFl4TlRNNU5qRTNOZz09O2F3c3NvX2t1OmFIUjBjSE02THk5ek1TNWhjbWxpWVM1amIyMHZVMjkxY21OcGJtY3ZUV0ZwYmk5aFpDOWpiR2xsYm5STFpXVndRV3hwZG1VdlUxTlBRV04wYVc5dWN3PT07YXdzc29fZmw6TVE9PQ%3D%3D%3AucRY3Rmu%2BWQclqZhwPR7HGSUlFI%3D&awsso_ap=ACM&passwordadapter=ThirdPartyUser&realm=PepsiCo-T&awsr=true",
              display: true
          },
          {
              app: "Ariba Prod",
              id: 1,
              tooltipText: 'Access Ariba Prod [PGCS]',
              url: "https://secure.pepsico.com/app/mypepsico_aribarowparent_1/exk1o1dwrglNBfmnb0h8/sso/saml?externalSite=true",
              display: true
          },
          {
              app: "Ariba Training",
              id: 1,
              tooltipText: 'Access Ariba Training [PGCS]',
              url: "https://pepsico.sharepoint.com/teams/ProcurementPMO-Digitalization/Shared Documents/Digitalization/Procurement Hub/../../../../../sites/PGCSSAPAribaandmyBuy?e=1%3a9987599a37804ce6b48ce4a5bdbe4152&SafelinksUrl=https%3a%2f%2fpepsico.sharepoint.com%2fsites%2fPGCSSAPAribaandmyBuy&xsdata=MDV8MDJ8Q2hyaXN0aW5hLlNoZWFoYW5AcGVwc2ljby5jb218YWVjMjFhMjIxOTdhNGFjYTBkZjIwOGRlYTQ3MzdmMDF8NDJjYzMyOTVjZDBlNDQ5Y2I5OGU1Y2U1YjU2MGMxZDN8MHwwfDYzOTEyOTAxMzE1MTc5NzMwNXxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=MTArM2U4Y25MYWlmT3dKa2NmNnpFcG9lSXFHYjE4aFNZdExlcmY2dGN6Yz0%3d",
              display: true
          },
          {
            app: "Icertis",
            id: 1,
            tooltipText: 'Manage contracts end-to-end with enterprise contract intelligence, compliance controls, and obligation tracking.',
            url: "https://pepsico.icertis.com",          
            display: true
          },
          {
            app: "Terzo",
            id: 1,
            tooltipText: 'AI-powered contract analytics to uncover spend insights, obligations, savings opportunities, and compliance risks.',
            url: "https://pepsico.terzocloud.com",
            display: true
          },
    ],
  },
  {
    id: 11,
    capability_name: "Productivity Report",
    capability_desc: "Maximize value with transparent tracking of savings and productivity gains.",
    info: "This app has restricted access",
    apps: [
      //https://app.powerbi.com/groups/b7a7cff4-9069-43a6-8e71-31ebcd6c17df/reports/597e1cff-94e6-42e6-a10f-f144270b2554/bc8479702f8711725912?ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&experience=power-bi
      {
          app: "PR Dashboard",
          id: 1,
          tooltipText: 'Easy to monitor procurement productivity, key KPIs, and value delivery across the globe',
          url: "https://spend360.mypepsico.com/productivity-dashboard",
          display: true
      },
      {
        app: "Power Steering",
        id: 2,
        tooltipText: 'Record and track savings projects — your single source for productivity reporting.',
        url: "https://psxl.psteering.com/PepsiCoNextGen/Home.epage",
        display: true
      },
      {
          app: "Cockpit - Global",
          id: 3,
          tooltipText: 'Your dashboard for Procurement KPIs, insights, and performance tracking.',
          url: "https://cockpit.mypepsico.com/views/ProductivityDirectMaterials/DirectsDetails",
          display: true
      },
      {
          app: "Cockpit - AMESA",
          id: 4,
          tooltipText: 'Your dashboard for Procurement KPIs, insights, and performance tracking.',
          url: "https://cockpit.mypepsico.com/#/views/GlobalProductivity_16898878449100/ProductivityOverview?:iid=1",
          display: true
      },
      {
          app: "Cockpit - APAC",
          id: 5,
          tooltipText: 'Your dashboard for Procurement KPIs, insights, and performance tracking.',
          url: "https://cockpit.mypepsico.com/#/views/PECNewMetrics/CommodityProductivity?:iid=1",
          display: true
      }
  ],
  },
  // {
  //   id: 12,
  //   capability_name: "Indirect Compliance",
  //   capability_desc: "Spend smart, comply better, grow faster.",
  //   apps: [
  //     {
  //       app: "Spendwise",
  //       id: 1,
  // tooltipText: 'Spendwise',
  //       url: "https://spendwise.mypepsico.com",
  //       display: true
  //     },
  //   ],
  // },
  {
    id: 13,
    capability_name: "R2P Insights",
    capability_desc: "Gain control and power your Requisition to Pay process.",
    apps: [
      {
          app: "myRIS",
          id: 1,
          tooltipText: 'View analytics for all catalogue-based spend — track compliance and adoption.',
          url: "https://app.powerbi.com/groups/me/reports/f12fad8f-5fff-4ab5-93eb-efe20cd6dcb1/1f88c127aca44206949a?ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&experience=power-bi",
          display: true
      },
      {
          app: "myBUY",
          id: 1,
          tooltipText: 'Quick, compliant indirect catalogue buying.',
          url: "https://s1.ariba.com/Buyer/Main/aw?awh=r&awssk=AkDf.YgRZAGtiA9I&realm=PepsiCo&dard=1",
          display: true
      },
      {
        app: "Insights Hub - NA",
        id: 1,
        tooltipText: "Your dashboard for 'Requisition to Pay' KPIs, insights, and performance tracking",
        url: "https://pepsico-prod.us-1.celonis.cloud/package-manager/ui/views/ui/spaces/4f7f4f54-00b9-41bc-8d02-203daf9dcf0a/packages/a8bafc12-ce8f-4c06-a1a5-2c7fdef168a8/nodes/bc618a1e-7a25-4bd3-9049-ff8489fd171e?activeTabs=process-cockpit:4acd50da-6cfc-4892-b77b-b090a2a7639c",
        display: true
      },
      {
        app: "Insights Hub - LATAM",
        id: 1,
        tooltipText: "Your dashboard for 'Requisition to Pay' KPIs, insights, and performance tracking",
        url: "https://pepsico-prod.us-1.celonis.cloud/package-manager/ui/views/ui/spaces/b9c7f8b1-fab0-4964-bc87-890d2772bd11/packages/40e40a60-ec96-4f77-a440-a8a7cb814f2e/nodes/5b76921c-fd21-471e-bc77-6d81fcc50798?activeTabs=process-cockpit-retro-po-test:4acd50da-6cfc-4892-b77b-b090a2a7639c",
        display: true
      },
      {
        app: "Insights Hub - India",
        id: 1,
        tooltipText: "Your dashboard for 'Requisition to Pay' KPIs, insights, and performance tracking",
        url: "https://pepsico-prod.us-1.celonis.cloud/package-manager/ui/views/ui/spaces/6cf6a9e5-fec8-4af0-aaf2-8e5f0c075274/packages/ff80062c-067d-4669-bca6-87fda5c50171/nodes/17f93c78-0a03-4f32-a9f2-7e925cae5fed",
        display: true
      },
    ],
  },
  {
    id: 14,
    capability_name: "Procurement Performance",
    capability_desc: "Actionable Insights, Powerful Procurement.",
    apps: [
      {
        app: "Performance Scorecard",
        id: 1,
        tooltipText: 'Measure, Track and improve procurement performance.',
        url: "https://app.powerbi.com/groups/bb67e797-8354-4b31-8834-ac9f40c14d6b/reports/945e8c64-4ff1-4c32-a127-5f11f327c146/afc3a589e3a53ec784aa?experience=power-bi",
        display: true
      },
    ],
  },
    {
        id: 15,
        capability_name: "PGCS Procurement Analytics Portal",
        capability_desc: "Review Power BI dashboards build by the PGCS Procurement Data and Analytics team.",
        apps: [
        {
            app: "PGCS Analytics",
            id: 1,
            tooltipText: 'Open Power BI dashboards on the PGCS Procurement Analytics Portal',
            url: "https://pepsico.sharepoint.com/teams/ProcurementPMO-Digitalization/Shared Documents/Digitalization/Procurement Hub/../../../../../sites/PGCSGlobalProcurementAnalytics?xsdata=MDV8MDJ8Q2hyaXN0aW5hLlNoZWFoYW5AcGVwc2ljby5jb218YWVjMjFhMjIxOTdhNGFjYTBkZjIwOGRlYTQ3MzdmMDF8NDJjYzMyOTVjZDBlNDQ5Y2I5OGU1Y2U1YjU2MGMxZDN8MHwwfDYzOTEyOTAxMzE1MTg3MDEwMHxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=UEc2L3VsMkJsUFF3Ym45N1FzQmFaeUptNEJRZGV1ZnFCOVNkWnpqZXl1VT0%3d",
            display: true
        },
        ],
    },
];

export { appConfigUAT };
